<template>
  <div class="mt-3">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>

    <div class="d-flex justify-content-between">
      <p style="font-weight: 600; color: #53BACA;">Datos de contacto</p>
      <em v-if="!formularioAgregar" class="plus_outline" v-b-tooltip.hover title="Agregar nuevo" style="width: 1.2em" @click="agregarContacto"></em>
    </div>

    <b-row v-if="formularioAgregar">
      <b-col>
        <b-form v-on:submit.prevent="guardarContacto" >
          <div>
            <label>Medio contacto: </label>
            <b-form-select
                v-model="contactoGuardar.idMedioContacto"
                :options="listaMediosContacto"
                value-field="idMedioContacto"
                text-field="descripcion"
                :state="contactoGuardar.idMedioContacto != null"
            ></b-form-select>
            <b-form-invalid-feedback :state="contactoGuardar.idMedioContacto != null">
              Se debe seleccionar una opción
            </b-form-invalid-feedback>
          </div>
          <div>
            <div
                v-if="contactoGuardar.idMedioContacto === 1 || contactoGuardar.idMedioContacto === 2 || contactoGuardar.idMedioContacto === 4">
              <label>Número: *</label>
              <VuePhoneNumberInput
                  v-model="contactoGuardar.contacto"
                  maxlength="13"
                  default-country-code="MX"
                  :translations="traslationsTxt"
                  placeholder="Ingresa número a 10 dígitos: *"
                  :state="contactoGuardar.contacto != null"
              />
              <b-form-invalid-feedback :state="contactoGuardar.contacto != null">
                Debe ingresar un número
              </b-form-invalid-feedback>
            </div>
            <div v-if="contactoGuardar.idMedioContacto === 3">
              <label> Correo: *</label>
              <b-form-input
                  type="email"
                  v-model="contactoGuardar.contacto"
                  placeholder="Correo: "
                  max="5"
                  :state="contactoGuardar.contacto != null"
              ></b-form-input>
              <b-form-invalid-feedback :state="contactoGuardar.contacto != null">
                Debe ingresar un correo
              </b-form-invalid-feedback>
            </div>
          </div>

          <div style="display: flex; flex-direction: row; justify-content: center;">
            <div style="padding:1%">
              <b-button variant="outline-primary" class="mt-4" type="submit" size="sm">
                Guardar Contacto
              </b-button>
            </div>
            <div style="padding:1%">
              <b-button variant="outline-danger" class="mt-4" size="sm" @click="formularioAgregar=false"
              >Cancelar
              </b-button
              >
            </div>
          </div>
        </b-form>
      </b-col>
    </b-row>

        <div style="justify-content: left; text-align: left">

          <div v-if="!formularioAgregar" >

            <b-table
                class="text-center"
                responsive
                id="contactos"
                :items="contactoPaciente"
                :fields="fieldsContactos"
                :per-page="registrosPorPagina"
                :current-page="paginaActual"

            >
              <template v-slot:cell(preferente)="row">
                <div>
                  <b-form-checkbox
                      switch
                      v-model="row.item.preferente"
                      @input="actualizarContactos()"
                  ></b-form-checkbox>
                </div>
              </template>
              <template v-slot:cell(acciones)="row">
                <div class="d-flex justify-content-center">
<!--                  <em class="edit_outline_svg mr-3" @click="activarEdicion(row.index)" style="width: 1.5em; cursor: pointer"></em>-->
                  <em v-if="row.item.registroActivo == true" @click="eliminarContacto(row.index)" class="delete_outline_svg" style="width: 1.5em;"></em>
                  <em v-else class="check_outline_green"  @click="restaurarContacto(row.index)"></em>
                </div>
              </template>
            </b-table>
            <b-pagination
                v-if="contactoPaciente.length > 6"
                align="center"
                v-model="paginaActual"
                :total-rows="contactoPaciente.length"
                :per-page="registrosPorPagina"
            ></b-pagination>

          </div>

        </div>
  </div>
</template>

<script>
import {PacienteService} from "@/apiServices/paciente/PacienteService";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  name: "ContactoPaciente",
  components: {
    VuePhoneNumberInput,
  },
  props: {
    idPaciente: Number,
  },
  data: () => ({
    registrosPorPagina: 6,
    paginaActual: 1,
    pacienteService: new PacienteService(),
    listaContacto: [],
    contactoPaciente: [],
    contactoGuardar: {
      idMedioContacto: null,
      contacto: null,
    },
    fieldsContactos: [
      {
        key: "medioContacto",
        label: "Medio",
      },
      {
        key: "contacto",
        label: "Datos",
      },
      {
        key: "preferente",
        label: "Preferente",
        thStyle: { width: "3%" },
      },
      "Acciones"
    ],
    formularioAgregar: false,
    idMedioContactoPaciente: null,
    listaMediosContacto: []
  }),
  created() {
    this.obtenerContactoPaciente();
    this.traerMediosContacto();
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {

  },
  watch: {
    idMedioContactoPaciente: function () {
      this.$emit("_setearValor", this.idMedioContactoPaciente);
      this.$forceUpdate();
    },

    parentescoLocal: {
      handler(newValue) {
        this.$emit("actualizarParentesco", newValue);
      },
      deep: true
    }
  },
  methods: {
    actualizarContactos(){
      this.$emit("actualizarContactos", this.contactoPaciente);
    },
    restaurarContacto(index){
      this.contactoPaciente[index].registroActivo = true;
      this.actualizarContactos();
    },
    eliminarContacto(index){
      this.contactoPaciente[index].registroActivo = false;
      this.actualizarContactos();
    },
    editarContacto(infoContacto){

      const urlContacto = this.$api + "paciente/actualizarContactoPx";
      this.$http
          .post(urlContacto, infoContacto)
          .then((response) => {
            if (response.data.data) {
              this.listaMediosContacto = response.data.data;
            }
          })
          .catch((err) => {
            console.error(err);
          });
    },
    activarEdicion(index) {
      this.contactoPaciente[index].editar = true;
    },
    agregarContacto() {
      this.formularioAgregar = true;
    },
    traerMediosContacto() {
      if(this.origen != 2){
        const urlContacto = this.$api + "catalogos/listaMediosContacto";
        this.$http
            .get(urlContacto)
            .then((response) => {
              if (response.data.data) {
                this.listaMediosContacto = response.data.data;
              }
            })
            .catch((err) => {
              console.error(err);
            });
      }
      else{
        this.listaContacto = [{
          idMedioContacto: 3,
          descripcion: "CORREO"
        }];
        this.contactoGuardar = {
          idMedioContacto: 3,
          contacto: null,
        };
      }
    },
    traerListaContacto() {
        const urlContacto = this.$api + "paciente/obtener/contactos";
        this.$http
            .post(urlContacto)
            .then((response) => {
              if (response.data.data) {
                this.listaContacto = response.data.data;
              }
            })
            .catch((err) => {
              console.error(err);
            });

    },
    obtenerContactoPaciente() {
      this.paginaActual = 1;
      const parametros = {idPaciente: this.idPaciente}
      this.pacienteService
          .obtenerMediosContactoPaciente(parametros)
          .then((response) => {
            this.contactoPaciente = response;
            this.actualizarContactos();
          })
          .catch((err) => {
            console.error(err);
          });
    },
    guardarContacto() {
      if (this.contactoGuardar.idMedioContacto !== 3) {
        if (this.contactoGuardar.contacto.replace(/\s+/g, "").length !== 10) {
          this.$swal({
            icon: "warning",
            text: "Los números de teléfono deben ser de 10 dígitos",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          return false;
        }
      }
      var datos = {
        idPaciente: this.idPaciente,
        idMedioContacto: this.contactoGuardar.idMedioContacto,
        contacto: this.contactoGuardar.contacto,
        idMedioContactoPaciente: null,
        preferente: true
      };

      const urlContacto = this.$api + "paciente/contactos/guardarNoRepetido";
      this.$http
          .put(urlContacto, datos)
          .then((response) => {
            if (response.data.success == true) {
              this.$swal({
                icon: "success",
                text: "Contacto guardado correctamente",
                confirmButtonText: "De acuerdo",
              });
              this.formularioAgregar = false;
              this.limpiarContactos();
              this.obtenerContactoPaciente();
            }
          })
          .catch((error) => {
            this.$swal({
              icon: "warning",
              text: error.response.data.message || "Ocurrió un error",
              confirmButtonText: "De acuerdo",
              confirmButtonColor: "#0e6ba9",
            });
          });
    },

    limpiarContactos(){
      this.contactoGuardar = {
        idPaciente: this.idPaciente,
        idMedioContacto: null,
        contacto: null,
        idMedioContactoPaciente: null,
        preferente: true
      };
    }
  },
};
</script>

<style scoped>
.editar-fila{
  background-color: pink;
}
</style>
